import { useEffect } from 'react'

import { gql, useQuery } from '@apollo/client'

import { CHAT_CUSTOMER_FRAGMENT } from 'Const'
import { ChatCustomer } from 'Types'

const CHAT_CUSTOMER_QUERY = gql`
  query ChatUser {
    currentCustomer {
      ...ChatCustomer
    }
  }
  ${CHAT_CUSTOMER_FRAGMENT}
`

const useChatCustomer = (): [ChatCustomer | undefined, { loading: boolean }] => {
  const { data, loading, refetch } = useQuery<{ currentCustomer: ChatCustomer }>(CHAT_CUSTOMER_QUERY, {
    fetchPolicy: 'cache-first',
  })

  useEffect(() => {
    const listener = (event: Event) => {
      if ('detail' in event) {
        const customEvent = event as CustomEvent
        if (customEvent.detail.source === 'js') {
          void refetch()
        }
      }
    }
    document.addEventListener('sign-up', listener)
    return () => document.removeEventListener('sign-up', listener)
  }, [refetch])

  return [data?.currentCustomer, { loading }]
}

export default useChatCustomer
